import React from "react";
import { makeStyles, alpha } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "inline-flex",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 10,
    overflow: "hidden",
    height: 40,
    maxWidth: "100%",
  },
  fullWidth: { display: "flex", width: "100%" },
  item: {
    flex: "1 1 auto",
    border: 0,
    borderRight: `1px solid ${theme.palette.divider}`,
    background: "transparent",
    color: theme.palette.text.secondary,
    font: "inherit",
    fontSize: 13,
    fontWeight: 500,
    padding: theme.spacing(0, 1.5),
    cursor: "pointer",
    whiteSpace: "nowrap",
    "&:last-child": { borderRight: 0 },
    "&:hover": { backgroundColor: theme.palette.action.hover },
    "&:focus-visible": { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: -2 },
  },
  selected: {
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    color: theme.palette.primary.main,
    fontWeight: 600,
    "&:hover": { backgroundColor: alpha(theme.palette.primary.main, 0.16) },
  },
}));

// Botões lado a lado onde só um fica ativo.
// options: [{ value, label }]
const SegmentedControl = ({ value, options, onChange, fullWidth, ariaLabel }) => {
  const classes = useStyles();
  return (
    <div
      role="radiogroup"
      aria-label={ariaLabel}
      className={`${classes.root} ${fullWidth ? classes.fullWidth : ""}`}
    >
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={o.value === value}
          className={`${classes.item} ${o.value === value ? classes.selected : ""}`}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
};

export default SegmentedControl;
